<section>
  <button (click)="copyBarcode()" class="copy-button">複製條碼</button>
  <div class="h-[400px] barcode-container">
    <div class="barcode-display" style="transform: rotate(90deg);">
      <svg #barcodeElement></svg>
    </div>
  </div>
</section>
